// deps
import styled from "styled-components";

// internal-deps
import { AriaHidden } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// widgets
import { FoodSymbolIconSvg } from "@cart-ui/widgets/food-symbol-icon";

export const ContainerStyled = styled.div`
    display: inline;
`;

export const NameStyled = styled.div`
    display: flex;
    align-items: start;
    gap: 4px;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    max-height: 3rem;
    overflow: hidden;
    word-break: break-word;
    position: relative;
`;

export const FoodSymbolStyled = styled(FoodSymbolIconSvg)`
    position: absolute;
    top: ${(props) => props.theme.spacing.xxxSmall};
`;

export const StyledItemName = styled(Text)<{ isMerchItem?: boolean }>`
    display: inline;
    margin-left: ${(props) => (props.isMerchItem ? props.theme.spacing.empty : props.theme.spacing.medium)};
`;

export const AriaHiddenCustomiseStyled = styled(AriaHidden)`
    display: flex;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const CustomiseTextStyled = styled(Text)`
    text-overflow: ellipsis;
    overflow: hidden;
    margin-right: 4px;
`;

export const CustomiseButtonStyled = styled.button`
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    text-align: left;
    -webkit-appearance: none;
    appearance: none;
    display: flex;
    align-items: center;
    margin-top: 2px;
`;
